import React from 'react';
import { forwardRef, ReactNode, useImperativeHandle } from 'react';
import { Form } from '@ant-design/compatible';
import { FormComponentProps, ValidationRule } from '@ant-design/compatible/lib/form';
import cx from 'classnames';
import DateRangePicker from '../../datePicker/DateRangePicker';

export type DateRange = {
  startDate: string;
  endDate: string;
};
type OutsideRange = {
  before: string;
  after: string;
};
interface IDateRangePickerFormProps extends FormComponentProps {
  className?: string;
  label?: string | ReactNode;
  name: string;
  rules?: ValidationRule[];
  initialValue: DateRange;
  onSelect?: (value: DateRange) => void;
  outsideRange?: OutsideRange;
  showTime?: boolean;
  outFormat: string;
  btnTextFormat?: string;
  startText?: string;
  endText?: string;
  format?: string;
  isEditable?: boolean;
  vertical?: boolean;
  subContent?: string | ReactNode;
  showInfo?: boolean;
}
const DateRangePickerForm = forwardRef<FormComponentProps, IDateRangePickerFormProps>((props, ref) => {
  const {
    className,
    form,
    label,
    rules,
    name,
    initialValue,
    onSelect = (value: DateRange) => {
      // null
    },
    vertical = false,
    subContent,
    showInfo = true,
    ...res
  } = props;
  const { getFieldDecorator } = form;

  useImperativeHandle(ref, () => ({
    form,
  }));

  return (
    <div className={className}>
      <Form.Item
        className={cx('date-ranger-picker-form', 'amondz-form', { 'with-label': label }, { vertical })}
        label={label}
      >
        {getFieldDecorator(name, {
          rules,
          initialValue,
          trigger: 'onSelect',
        })(<DateRangePicker onSelect={onSelect} {...res} />)}
      </Form.Item>
      {subContent && showInfo ? <div className="amondz-form-sub-content"> {subContent}</div> : null}
    </div>
  );
});
DateRangePickerForm.displayName = 'DateRangePickerForm';

export default DateRangePickerForm;
